// extracted by mini-css-extract-plugin
export default {"AppTitleContainer":"AppTitle-module__AppTitleContainer--Nw6zi","Heading":"AppTitle-module__Heading--xDXN6"};